<div class="app-content">
    <div class="application-header">
        <div class="hs-dashboard-header">
            @if (widgetInfo) {
                <div class="dashboard-name">
                    <h1 [class.highlight]="widgetInfo.name">{{ widgetInfo.name ? widgetInfo.name : 'Enter Widget Name' }}</h1>

                    @if (widgetInfo.id) {
                        <cc-icon
                            [icon]="'dots-vertical'"
                            [size]="'xlarge'"
                            title="Widget Properties"
                            (iconClicked)="showSaveDialog()"
                        >
                        </cc-icon>
                    }

                    <div>
                        <button class="ghost-btn" [disabled]="!enableSave" (click)="saveWidget()">Save</button>

                        @if (widgetInfo.id) {
                            <button class="ghost-btn" (click)="showSaveDialog(true)">Save As</button>
                        }

                        <button class="ghost-btn" [disabled]="!enableSave" (click)="revertChanges.emit(widgetInfo.id)">Revert</button>
                    </div>
                </div>
            }
        </div>

        <div class="dashboard-filter">
            <div class="filter">
                <ddv-dashboard-filters
                    #dashboardFilters
                    [clientCode]="clientCode ?? ''"
                    [inMultiEnvironment]="isMultiClient"
                    [funds]="funds"
                    [clients]="clients"
                    [fuzzyDates]="ccFuzzyDates"
                    [queryParams]="filters"
                    [bypassSlowDataApproval]="true"
                    [namedQueries]="namedQuery ? [namedQuery] : []"
                    (applyFunds)="onApplySelectedFunds($event)"
                    (applyClients)="onApplySelectedClients($event)"
                    (applyDateFilter)="onApplyDateChanges($event)"
                    (applyAdditionalFilters)="onApplyAdditionalFilterChanges($event)"
                >
                    <ddv-additional-filters-dropdown
                        [widgetId]="manageWidgetId"
                        [filters]="nonUdfFilters"
                        (filtersApplied)="onApplyAdditionalFilters($event)"
                    >
                    </ddv-additional-filters-dropdown>
                </ddv-dashboard-filters>
            </div>
         </div>
    </div>
</div>
